var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',[(_vm.stats)?_c('dashboard-member-stats',{attrs:{"members-stats-resource":_vm.stats}}):_vm._e(),_c('dashboard-member-list',{class:_vm.stats ? 'mt-10':'',attrs:{"dashboard-resource":_vm.dashboardResource}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }